import React, { useState } from "react";
import StorylaneContext from "./StoryLaneContext";

const StorylaneProvider = ({ children }) => {
    const [videoURL, setVideoURL] = useState('');
    return (
        <StorylaneContext.Provider
            value={{
                videoURL,
                setVideoURL
            }}
        >
            {children}
        </StorylaneContext.Provider>
    );
};

export default StorylaneProvider;
